"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const SearchInput = ({ onSearchChange, placeholder }) => {
    const onChange = (0, lodash_1.debounce)((searchText) => {
        onSearchChange(searchText);
    }, 750);
    return (react_1.default.createElement("div", { className: `boutik-customer-account-orders-filters-searchInput-container` },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faMagnifyingGlass, className: `boutik-customer-account-orders-filters-searchInput-icon` }),
        react_1.default.createElement("input", { className: `boutik-customer-account-orders-filters-searchInput-input`, placeholder: placeholder, onChange: (event) => onChange(event.target.value), style: { border: "none", outline: "none" } })));
};
exports.SearchInput = SearchInput;
//# sourceMappingURL=SearchInput.js.map